import { render, staticRenderFns } from "./PlaceOverview.vue?vue&type=template&id=3a1eb46f&scoped=true&"
import script from "./PlaceOverview.vue?vue&type=script&lang=ts&"
export * from "./PlaceOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1eb46f",
  null
  
)

export default component.exports